import api from './api';

export async function fetchEditorPresets() {
    const { data } = await api.get('/editor-presets');
    return Array.isArray(data) ? data : [];
}

export async function createEditorPreset(payload) {
    const { data } = await api.post('/editor-presets', payload);
    return data;
}

export async function updateEditorPreset(id, payload) {
    const { data } = await api.put(`/editor-presets/${id}`, payload);
    return data;
}

export async function deleteEditorPreset(id) {
    await api.delete(`/editor-presets/${id}`);
}
